export const isMobile = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isMobileDevice = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|windows phone/i.test(userAgent);
    
    return isMobileDevice || (isTouchDevice && window.matchMedia("(max-width: 767px)").matches);
}
